module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "appendToBody": true,
      "placeInTop": true,
      "pxFromTop": 1,
      "ariaLabel": _vm.$t('vue2.school_users.edit')
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "d-modal school-user-modal text-dark",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.school_users.edit')))]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle d-modal__header__close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [_c('div', {
    staticClass: "school-user-modal__profile"
  }, [_c('label', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        placement: 'bottom'
      }),
      expression: "{arrow: true, placement: 'bottom'}"
    }],
    staticClass: "school-user-modal__avatar",
    class: {
      'school-user-modal__avatar--loading': _vm.isUploadingImage
    },
    attrs: {
      "content": _vm.$t('vue2.school_users.change_photo')
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.thumbUrl,
      "alt": _vm.user.name,
      "width": "64",
      "height": "64"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "school-user-modal__file",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.onImageSelected
    }
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "school-user-modal__profile__name"
  }, [_vm._v(_vm._s(_vm.user.name))]), _vm._v(" "), _c('div', {
    staticClass: "school-user-modal__profile__seen"
  }, [_vm._v(_vm._s(_vm.lastSeen))])])]), _vm._v(" "), _c('div', {
    staticClass: "do-input-group-flex"
  }, [_c('div', {
    staticClass: "school-user-modal__grow"
  }, [_c('label', {
    staticClass: "d-label",
    attrs: {
      "for": "school-user-name"
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.school_users.name')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "d-input width-100",
    attrs: {
      "id": "school-user-name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "school-user-modal__initials"
  }, [_c('label', {
    staticClass: "d-label",
    attrs: {
      "for": "school-user-initials"
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.school_users.initials')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.initials),
      expression: "form.initials"
    }],
    staticClass: "d-input width-100",
    attrs: {
      "id": "school-user-initials",
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.initials)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "initials", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "do-input-group"
  }, [_c('label', {
    staticClass: "d-label",
    attrs: {
      "for": "school-user-email"
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.school_users.email')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.email),
      expression: "form.email"
    }],
    staticClass: "d-input width-100",
    attrs: {
      "id": "school-user-email",
      "type": "email"
    },
    domProps: {
      "value": (_vm.form.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "do-input-group"
  }, [_c('label', {
    staticClass: "d-label",
    attrs: {
      "for": "school-user-phone"
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.school_users.phone')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.phone),
      expression: "form.phone"
    }],
    staticClass: "d-input width-100",
    attrs: {
      "id": "school-user-phone",
      "type": "tel",
      "placeholder": "12 34 56 78"
    },
    domProps: {
      "value": (_vm.form.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "phone", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.showSsn) ? _c('div', {
    staticClass: "do-input-group"
  }, [_c('label', {
    staticClass: "d-label",
    attrs: {
      "for": "school-user-ssn"
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.school_users.ssn')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.ssn),
      expression: "form.ssn"
    }],
    staticClass: "d-input width-100",
    attrs: {
      "id": "school-user-ssn",
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.ssn)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "ssn", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.loginField) ? _c('div', {
    staticClass: "do-input-group"
  }, [_c('label', {
    staticClass: "d-label",
    attrs: {
      "for": "school-user-login"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.loginField.label) + "\n          "), (_vm.loginField.hint) ? _c('span', {
    staticClass: "school-user-modal__label-hint"
  }, [_vm._v(_vm._s(_vm.loginField.hint))]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form[_vm.loginField.key]),
      expression: "form[loginField.key]"
    }],
    staticClass: "d-input width-100",
    attrs: {
      "id": "school-user-login",
      "type": "text",
      "disabled": !_vm.isEditable(_vm.loginField.key)
    },
    domProps: {
      "value": (_vm.form[_vm.loginField.key])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, _vm.loginField.key, $event.target.value)
      }
    }
  }), _vm._v(" "), (!_vm.isEditable(_vm.loginField.key)) ? _c('p', {
    staticClass: "school-user-modal__hint"
  }, [_vm._v(_vm._s(_vm.$t('vue2.school_users.not_editable_yet')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "do-input-group"
  }, [_c('label', {
    staticClass: "d-label",
    attrs: {
      "for": "school-user-employee-id"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.school_users.employee_id')) + "\n          "), _c('span', {
    staticClass: "school-user-modal__label-hint"
  }, [_vm._v(_vm._s(_vm.$t('vue2.school_users.employee_id_hint')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.employee_id),
      expression: "form.employee_id"
    }],
    staticClass: "d-input width-100",
    attrs: {
      "id": "school-user-employee-id",
      "type": "text",
      "disabled": !_vm.isEditable('employee_id')
    },
    domProps: {
      "value": (_vm.form.employee_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "employee_id", $event.target.value)
      }
    }
  }), _vm._v(" "), (!_vm.isEditable('employee_id')) ? _c('p', {
    staticClass: "school-user-modal__hint"
  }, [_vm._v(_vm._s(_vm.$t('vue2.school_users.not_editable_yet')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons"
  }, [_c('div', [_c('a', {
    staticClass: "school-user-modal__link",
    attrs: {
      "href": _vm.tasksUrl
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.school_users.see_tasks')))])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "do-bttn",
    attrs: {
      "disabled": _vm.isSaving
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.school_users.cancel')) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--disabled': !_vm.isValid || _vm.isSaving,
      'do-bttn--submit--loading': _vm.isSaving
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.school_users.save')) + "\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ac05b468!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SchoolUsers/SchoolUserModal.vue
// module id = 2086
// module chunks = 1